/**
 * Получить хэш карты
 */
export function cardDataHash(user: any) {
  return user?.physicalUserCard?.cardHash;
}
